<section class="grid">
  @if (accessMatrixService?.isAvailableModule(RouteTypeEnum.DASHBOARD, ModuleTypeEnum.DASHBOARD_WIDGET, SubModuleTypeEnum.DASHBOARD_WIDGET_ALL_DB)) {
    <ms-stat-card-widget [value]="widgets.numberOfDb" [progressPercent]="100"
                         [title]="'Nombre total de db'"></ms-stat-card-widget>
  }
  @if (accessMatrixService?.isAvailableModule(RouteTypeEnum.DASHBOARD, ModuleTypeEnum.DASHBOARD_WIDGET, SubModuleTypeEnum.DASHBOARD_WIDGET_CLUSTER_1)) {
    <ms-stat-card-widget [value]="widgets.cluster_1" [progressPercent]="(widgets.cluster_1 / widgets.numberOfDb * 100)"
                         [title]="'Cluster 1'"></ms-stat-card-widget>
  }
  @if (accessMatrixService?.isAvailableModule(RouteTypeEnum.DASHBOARD, ModuleTypeEnum.DASHBOARD_WIDGET, SubModuleTypeEnum.DASHBOARD_WIDGET_CLUSTER_2)) {
    <ms-stat-card-widget [value]="widgets.cluster_2" [progressPercent]="(widgets.cluster_2 / widgets.numberOfDb * 100)"
                         [title]="'Cluster 2'"></ms-stat-card-widget>
  }
  @if (accessMatrixService?.isAvailableModule(RouteTypeEnum.DASHBOARD, ModuleTypeEnum.DASHBOARD_WIDGET, SubModuleTypeEnum.DASHBOARD_WIDGET_DUPLICATE)) {
    <ms-stat-card-widget [value]="widgets.duplicate" [progressPercent]="(widgets.duplicate / widgets.numberOfDb * 100)"
                         [title]="'Doublons potentiels'"></ms-stat-card-widget>
  }
</section>
@if (accessMatrixService?.isAvailableModule(RouteTypeEnum.DASHBOARD, ModuleTypeEnum.DASHBOARD_WIDGET, SubModuleTypeEnum.DASHBOARD_WIDGET_NEW_USER) || accessMatrixService?.isAvailableModule(RouteTypeEnum.DASHBOARD, ModuleTypeEnum.DASHBOARD_WIDGET, SubModuleTypeEnum.DASHBOARD_WIDGET_USER_FULL_STEP)) {
  <section class="grid">
    @if (accessMatrixService?.isAvailableModule(RouteTypeEnum.DASHBOARD, ModuleTypeEnum.DASHBOARD_WIDGET, SubModuleTypeEnum.DASHBOARD_WIDGET_NEW_USER)) {
      <ms-stat-card-widget [value]="widgets.newUserLast24h"
                           [progressPercent]="(widgets.newUserLast24h / widgets.steps.step_6 * 100)"
                           [title]="'Nouveaux utilisateurs depuis 24h'"></ms-stat-card-widget>
    }

    @if (accessMatrixService?.isAvailableModule(RouteTypeEnum.DASHBOARD, ModuleTypeEnum.DASHBOARD_WIDGET, SubModuleTypeEnum.DASHBOARD_WIDGET_USER_FULL_STEP)) {
      <ms-stat-card-widget
        [value]="(widgets.steps.step_1 + widgets.steps.step_2 + widgets.steps.step_3 + widgets.steps.step_4 + widgets.steps.step_5 + widgets.steps.step_6)"
        [progressPercent]="100"
        [title]="'Nombre d\'utilisateurs'"></ms-stat-card-widget>
    }

    @if (accessMatrixService?.isAvailableModule(RouteTypeEnum.DASHBOARD, ModuleTypeEnum.DASHBOARD_WIDGET, SubModuleTypeEnum.DASHBOARD_WIDGET_USER_FULL_STEP)) {
      <ms-stat-card-widget [value]="widgets.steps.step_6"
                           [progressPercent]="((widgets.steps.step_6 / (widgets.steps.step_1 + widgets.steps.step_2 + widgets.steps.step_3 + widgets.steps.step_4 + widgets.steps.step_5 + widgets.steps.step_6)) * 100)"
                           [title]="'Usr totalement configurés'"></ms-stat-card-widget>
    }

  </section>
}

<section class="columns">
  <ms-last-activity-widget [title]="'Activités récentes'"></ms-last-activity-widget>
  <ms-alert-widget [title]="'Alerts & statuts'" [alerts]="alerts"></ms-alert-widget>
</section>

@if (accessMatrixService?.isAvailableModule(RouteTypeEnum.DASHBOARD, ModuleTypeEnum.DASHBOARD_WIDGET, SubModuleTypeEnum.DASHBOARD_WIDGET_USER_WALLONIA)) {
  <section class="grid">
    <ms-pie-chart-widget title="Répartition géographique"
                       [labels]="['Wallonie', 'Flandre', 'Bruxelles']"
                       [data]="[widgets.districtRepartition?.wal, widgets.districtRepartition?.fla, widgets.districtRepartition?.bxl]"
                       [colors]="['#b91010', '#c5c222', '#0e66e9']"
                       type="pie"></ms-pie-chart-widget>
  </section>
}



<!--
<mat-grid-list class="mg-top-10" cols="6" rowHeight="4:1">

</mat-grid-list>
<mat-grid-list class="mg-top-10" cols="6" rowHeight="4:1">
  <mat-grid-tile *ngIf="accessMatrixService?.isAvailableModule(RouteTypeEnum.DASHBOARD, ModuleTypeEnum.DASHBOARD_WIDGET, SubModuleTypeEnum.DASHBOARD_WIDGET_USER_NEVER_CONNECTED)">
    <div id="widget-step_1" class="dashboard-bloc widget-steps">
      <div class="dashboard-bloc-content">
        <div class="bloc-container">
          <div class="bloc-container-icon">
            <mat-icon class="dashboard-icon">supervised_user_circle</mat-icon>
          </div>
          <div class="bloc-container-number">
            {{widgets.steps?.step_1}}
          </div>
        </div>
        <div class="bloc-bottom-title-container">
          Usr jamais connectés
        </div>
      </div>
    </div>
  </mat-grid-tile>
  <mat-grid-tile *ngIf="accessMatrixService?.isAvailableModule(RouteTypeEnum.DASHBOARD, ModuleTypeEnum.DASHBOARD_WIDGET, SubModuleTypeEnum.DASHBOARD_WIDGET_USER_PASSWORD_STEP)">
    <div id="widget-step_2" class="dashboard-bloc widget-steps">
      <div class="dashboard-bloc-content">
        <div class="bloc-container">
          <div class="bloc-container-icon">
            <mat-icon class="dashboard-icon">password</mat-icon>
          </div>
          <div class="bloc-container-number">
            {{widgets.steps?.step_2}}
          </div>

        </div>
        <div class="bloc-bottom-title-container">
          Usr stoppés après config mdp
        </div>
      </div>
    </div>
  </mat-grid-tile>
  <mat-grid-tile *ngIf="accessMatrixService?.isAvailableModule(RouteTypeEnum.DASHBOARD, ModuleTypeEnum.DASHBOARD_WIDGET, SubModuleTypeEnum.DASHBOARD_WIDGET_USER_HCP_STEP)">
    <div id="widget-step_3" class="dashboard-bloc widget-steps">
      <div class="dashboard-bloc-content">
        <div class="bloc-container">
          <div class="bloc-container-icon">
            <mat-icon class="dashboard-icon">man</mat-icon>
          </div>
          <div class="bloc-container-number">
            {{widgets.steps?.step_3}}
          </div>

        </div>
        <div class="bloc-bottom-title-container">
          Usr stoppés après config hcp
        </div>
      </div>
    </div>
  </mat-grid-tile>
  <mat-grid-tile *ngIf="accessMatrixService?.isAvailableModule(RouteTypeEnum.DASHBOARD, ModuleTypeEnum.DASHBOARD_WIDGET, SubModuleTypeEnum.DASHBOARD_WIDGET_USER_ADR_STEP)">
    <div id="widget-step_4" class="dashboard-bloc widget-steps">
      <div class="dashboard-bloc-content">
        <div class="bloc-container">
          <div class="bloc-container-icon">
            <mat-icon class="dashboard-icon">house</mat-icon>
          </div>
          <div class="bloc-container-number">
            {{widgets.steps?.step_4}}
          </div>

        </div>
        <div class="bloc-bottom-title-container">
          Usr stoppés après config adr
        </div>
      </div>
    </div>
  </mat-grid-tile>
  <mat-grid-tile *ngIf="accessMatrixService?.isAvailableModule(RouteTypeEnum.DASHBOARD, ModuleTypeEnum.DASHBOARD_WIDGET, SubModuleTypeEnum.DASHBOARD_WIDGET_USER_INVOICE_STEP)">
    <div id="widget-step_5" class="dashboard-bloc widget-steps">
      <div class="dashboard-bloc-content">
        <div class="bloc-container">
          <div class="bloc-container-icon">
            <mat-icon class="dashboard-icon">euro</mat-icon>
          </div>
          <div class="bloc-container-number">
            {{widgets.steps?.step_5}}
          </div>

        </div>
        <div class="bloc-bottom-title-container">
          Usr stoppés après config facturation
        </div>
      </div>
    </div>
  </mat-grid-tile>
</mat-grid-list>
-->
<ms-activity-indicator-with-messages [fullWidth]="true" [isLoading]="isLoading" [overlay]="true" [messages]="messages"></ms-activity-indicator-with-messages>
